export const findAgencyByName = (agencyName, agencies) => {
  if (!agencyName || !Array.isArray(agencies)) return null;

  // UNSAFE temporary fallback: agency names are not guaranteed to be unique, so the first exact match may be wrong.
  return agencies.find((agency) => agency?.name === agencyName) || null;
};
